import React from "react";
import { Divider, Link, makeStyles, Paper } from "@material-ui/core";
import { News } from "../domain/News";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import ReactMarkdown from "react-markdown";
import { GovUkLogo } from "./images/GovUkLogo";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
    marginBottom: 30,
    minHeight: 100,
    ...theme.list.itemPrimary,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  logoContainer: {
    height: 30,
    float: "right",
  },
  content: {
    minHeight: 40,
  },
  footer: {
    textAlign: "right",
    marginTop: 5,
  },
}));

type NewsListItemProps = {
  newsItem: News;
};

export const NewsListItemGovUk: React.FC<NewsListItemProps> = ({
  newsItem,
}) => {
  const classes = useStyles();

  return (
    <Link target="_blank" href={newsItem.link} component="a" underline="none">
      <Paper className={classes.root} square>
        <div className={classes.logoContainer}>
          <GovUkLogo />
        </div>

        <h3>{newsItem.title}</h3>
        <div className={classes.content}>
          <ReactMarkdown>{newsItem.excerpt}</ReactMarkdown>
        </div>
        <Divider />
        <div className={classes.footer}>
          <b>Published on</b>{" "}
          {formatUtcDate(
            newsItem.publishedDate,
            standardDateFormats.FULL_DATE_TIME
          )}
        </div>
      </Paper>
    </Link>
  );
};
